
import { Link } from 'react-router-dom';
import './App.css';
import '@fontsource/roboto/500.css';

function Footer({data}) {
  return (
    <>
          <div className="row p-2 justify-content-center">
            {/* <div className="col-md-3 col-sm-3"></div> */}
            <div className="col-md-1 col-sm-2"></div>
            <div className="col-md-3 col-sm-10" style={{ textAlign: 'center', padding: 16 }}>
            
                  <nav style={{ marginBottom: 16 }}>
                    <p><Link to="/" hidden={!data[0]}>Home</Link> {' '}</p>
                    <p><Link to="/Aboutus" hidden={!data[1]}>About Us</Link> {' '}</p>
                    <p><Link to="/Contactus" hidden={!data[2]}>Contact Us</Link> {' '}</p>
                    
                    <p><Link to="/Uttar-Pradesh-Noida-Noida-Extension-Labour-Helper-Manson-Tiles-Mistri-Heavy-Labour-Painter">
                      Uttar-Pradesh-Noida-Noida-Extension-Labour-Helper-Manson-Tiles-Mistri-Heavy-Labour-Painter    
                    </Link>  {' '}</p>
                    <p><Link to="/Uttar-Pradesh-Greater-Noida-Labour-Helper-Manson-Tiles-Mistri-Heavy-Labour-Painter">
                      Uttar-Pradesh-Greater-Noida-Labour-Helper-Manson-Tiles-Mistri-Heavy-Labour-Painter
                    </Link> {' '}</p>
                    <p><Link to="/Uttar-Pradesh-Ghaziabad-Labour-Helper-Manson-Tiles-Mistri-Heavy-Labour-Painter">
                    Uttar-Pradesh-Ghaziabad-Labour-Helper-Manson-Tiles-Mistri-Heavy-Labour-Painter
                    </Link> {' '}</p>
                    <p><Link to="/Haryana-Faridabad-Labour-Helper-Manson-Tiles-Mistri-Heavy-Labour-Painter">
                      Haryana-Faridabad-Labour-Helper-Manson-Tiles-Mistri-Heavy-Labour-Painter
                    </Link> {' '}</p>
                    <p><Link to="/Haryana-Gurugram-Labour-Helper-Manson-Tiles-Mistri-Heavy-Labour-Painter">
                      Haryana-Gurugram-Labour-Helper-Manson-Tiles-Mistri-Heavy-Labour-Painter
                    </Link> {' '}</p>
                    <p><Link to="/New-Delhi-Dwarka-Labour-Helper-Manson-Tiles-Mistri-Heavy-Labour-Painter">
                      New-Delhi-Dwarka-Labour-Helper-Manson-Tiles-Mistri-Heavy-Labour-Painter
                    </Link> {' '}</p>                    
                  </nav>
            </div>            
            <div class="col-md-4 col-sm-12" style={{ textAlign: 'center', padding: 16 }}>
              <p><a href="https://sellrent.in">SellRent.In</a></p>              
              <p class="p-2"><b>DONATION</b></p>
              <p>We need your support.</p>
              <p><img src="../../../../assets/img/donation.jpg" alt="QR donation payment" width="40%"></img></p>
            </div>
            <div class="col-md-4 col-sm-12" style={{ textAlign: 'center', padding: 16 }}>
              <p>Contact Us</p>
              <p>9717 800 805, 85100 35195, 78385 40774</p>
              <p>Email: <a href="mailto:rajugupta5518@gmail.com">rajugupta5518@gmail.com</a></p>
              <p>Email : <a href="mailto:labourchowk7@gmail.com">labourchowk7@gmail.com</a></p>
              <hr></hr>
              <p><a href="https://www.linkedin.com/in/labour-chowk-64b439239/" target="new">Linkedin</a></p>
              <p><a href="https://www.instagram.com/labourchowk7/" target="new">Instagram</a></p>
              <p><a href="https://www.facebook.com/labourchowkin-546078172577320" target="new">Facebook</a></p>

            </div>

            {/* <div class="col-md-3 col-sm-3"></div> */}

            
            {/* <div class="col-md-3 col-sm-3"></div>
            <div class="col-md-3 col-sm-3"></div>
            <div class="col-md-3 col-sm-3"></div> */}
            
          </div> 
    </>
    );
}

export default Footer;


